import React, { useMemo } from "react";
import { observer } from "mobx-react";
import emissionViewStore from "../../../Store/marco/emissionViewStore";
import { getConstByStandard } from "../../utils/getConstFileByStandard";
//翻譯
import { useTranslation } from "react-i18next";
export const EmissionActivityDeleteModal = observer(({ handleDelete }) => {
  const store = emissionViewStore;
  const CONST = getConstByStandard(store.standardId);
  const category = CONST.category;
  const { t } = useTranslation("ActivityMain");
  const { itemName } = emissionViewStore.confirmDeleteEmissionActivityData;

  const message = useMemo(
    () => `${t("Are you sure you want to delete")} ${itemName}?`,
    [t] // ← 把所有會變的值都放進去
  );

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw", // 讓背景覆蓋整個視窗
        height: "100vh",
        background: "rgba(0, 0, 0, 0.5)", // 半透明背景
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          width: "300px",
        }}
      >
        <p style={{ textAlign: "left" }}>{message}</p>

        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            marginTop: "20px",
          }}
        >
          <button
            style={{
              backgroundColor: "rgb(200,200,200)",
              color: "black",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => {
              emissionViewStore._handleSetConfirmDeleteEmissionActivityModal(
                "",
                "",
                false
              );
            }}
          >
            {t("Cancel")}
          </button>
          <button
            style={{
              backgroundColor: "white",
              color: "red",
              border: "1px solid red",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => {
              handleDelete(
                emissionViewStore.confirmDeleteEmissionActivityData.id
              );
              emissionViewStore._handleSetConfirmDeleteEmissionActivityModal(
                "",
                "",
                false
              );
            }}
          >
            {t("Delete")}
          </button>
        </div>
      </div>
    </div>
  );
});
